//video-controller
export const VideoAPI = {
  getById: (id) => `/api/video/admin/${id}`,
  update: (id) => `/api/video/admin/${id}`,
  list: () => `/api/video/admin`,
  create: () => `/api/video/admin`,
  delete: (id) => `/api/video/admin/${id}`,
  form: () => `/api/video/admin/form`,
  analyticProtected: (page, size) =>
    `/api/video/admin/analytic?page=${page}&size=${size}`,
  analyticPublic: (page, size) =>
    `/api/video/admin/analytic/mini-micro?page=${page}&size=${size}`,
};

//tag-controller
export const TagAPI = {
  getById: (id) => `/api/tag/admin/${id}`,
  update: (id) => `/api/tag/admin/${id}`,
  delete: (id) => `/api/tag/admin/${id}`,
  deactivate: (id) => `/api/tag/admin/deactivate/${id}`,
  activate: (id) => `/api/tag/admin/activate/${id}`,
  list: () => `/api/tag/admin`,
  create: () => `/api/tag/admin`,
  form: () => `/api/tag/admin/form`,
};

//slider-controller
export const SliderAPI = {
  getById: (id) => `/api/slider/admin/${id}`,
  update: (id) => `/api/slider/admin/${id}`,
  delete: (id) => `/api/slider/admin/${id}`,
  list: () => `/api/slider/admin`,
  create: () => `/api/slider/admin`,
};

//reels-controller
export const ReelsAPI = {
  getById: (id) => `/api/reel/admin/${id}`,
  update: (id) => `/api/reel/admin/${id}`,
  delete: (id) => `/api/reel/admin/${id}`,
  list: () => `/api/reel/admin`,
  create: () => `/api/reel/admin`,
  statistic: () => `/api/reel/admin/clicks`,
};

//section-controller
// api/section.js
export const SectionAPI = {
  getById: (id) => `/api/section/admin/${id}`,
  update: (id) => `/api/section/admin/${id}`,
  list: () => `/api/section/admin`,
};

//role-controller
export const RoleAPI = {
  getById: (id) => `/api/role/admin/${id}`,
  update: (id) => `/api/role/admin/${id}`,
  delete: (id) => `/api/role/admin/${id}`,
  list: () => `/api/role/admin`,
  create: () => `/api/role/admin`,
  form: () => `/api/role/admin/form`,
};

//product-controller
export const ProductAPI = {
  getById: (id) => `/api/product/admin/${id}`,
  update: (id) => `/api/product/admin/${id}`,
  delete: (id) => `/api/product/admin/${id}?id=${id}`,
  list: () => `/api/product/admin`,
  create: () => `/api/product/admin`,
};

//channel-controller
export const ChannelAPI = {
  getById: (id) => `/api/channel/admin/${id}`,
  update: (id) => `/api/channel/admin/${id}`,
  delete: (id) => `/api/channel/admin/${id}`,
  list: () => `/api/channel/admin`,
  create: () => `/api/channel/admin`,
  form: () => `/api/channel/admin/form`,
};

//category-controller
export const CategoryAPI = {
  getById: (id) => `/api/category/admin/${id}`,
  update: (id) => `/api/category/admin/${id}`,
  delete: (id) => `/api/category/admin/${id}`,
  list: () => `/api/category/admin`,
  create: () => `/api/category/admin`,
  form: () => `/api/category/admin/form`,
};

//administrator-controller
export const AdministratorAPI = {
  getById: (id) => `/api/administrator/admin/${id}`,
  update: (id) => `/api/administrator/admin/${id}`,
  delete: (id) => `/api/administrator/admin/${id}`,
  list: () => `/api/administrator/admin`,
  create: () => `/api/administrator/admin`,
  login: () => `/api/administrator/admin/login`,
  logout: () => `/api/administrator/admin/logout`,
  me: () => `/api/administrator/admin/me`,
};

//user-controller
export const UserAPI = {
  getById: (id) => `/api/user/admin/${id}`,
  update: (id) => `/api/user/admin/${id}`,
  delete: (id) => `/api/user/admin/${id}`,
  list: () => `/api/user/admin`,
  create: () => `/api/user/admin`,
  form: () => `/api/user/admin/owner/form`,
  deactivateUser: (id) => `/api/user/admin/deactivate/${id}`,
  activateUser: (id) => `/api/user/admin/activate/${id}`,
  totalSalesDetail: () => `/api/user/admin/statistic/total-sales-detail`,
};

//course-controller
export const CourseAPI = {
  list: () => `/api/course/admin`,
  create: () => `/api/course/admin`,
  getById: (id) => `/api/course/admin/${id}`,
  update: (id) => `/api/course/admin/${id}`,
  delete: (id) => `/api/course/admin/${id}`,
  form: (val) => `/api/course/admin/form?channelId=${val}`,
};

//menu-controller
export const MenuAPI = {
  form: () => `/api/menu/admin/form`,
};

//Login
export const userLogin = () => `/api/adm/v1/administrator/admin/login`;
export const userLogout = () => `/api/adm/v1/administrator/admin/logout`;

//blog
export const getBlogList = (id) =>
  id == 0 ? `/api/plt/v1/blog/admin` : `/api/plt/v1/blog/admin/${id}`;
export const pathCreateBlog = () => `/api/plt/v1/blog/admin`;
export const pathDeleteBlog = (id) => `/api/plt/v1/blog/admin/${id}`;

//receipt-controller
export const ReceiptAPI = {
  getById: (id) => `/api/receipt/admin/${id}`,
  get: () => `/api/receipt/admin`,
  manualCart: (id) => `/api/receipt/admin/manual-finish?id=${id}`,
  manualFiscalization: (id) => `/api/receipt/admin/manual-fiscalization/${id}`,
  manualChangeDeliveryStatus: (id) => `/api/receipt/deliver/${id}`,

  receiptTotalSales: (year) => `/api/receipt/admin/total-sales?year=${year}`,
  receiptTotalSalesOnline: () => `/api/receipt/admin/total-sales-online`,
  receiptTotalSalesDelivery: () => `/api/receipt/admin/total-sales-on-delivery`,
  receiptTotalPrice: (year) => `/api/receipt/admin/total-price?year=${year}`,
  receiptTotalPriceOnline: () => `/api/receipt/admin/total-price-online`,
  receiptTotalPriceDelivery: () => `/api/receipt/admin/total-price-on-delivery`,
  receiptPendingDeliveries: () => `/api/receipt/admin/pending-deliveries`,
  receiptMonthlySales: (year) =>
    `/api/receipt/admin/monthly-sales?year=${year}`,
  receiptMonthlyRevenue: (year) =>
    `/api/receipt/admin/monthly-revenue?year=${year}`,
  receiptLastReceipt: () => `/api/receipt/admin/last-receipt`,
};
//contact
export const ContactAPI = {
  getById: (id) => `/api/contact/admin/${id}`,
  list: () => `api/contact/admin`,
  educatorList: () => `api/contact/admin/educator`,
};
//contact
export const PageAPI = {
  update: (id) => `/api/content/admin/${id}`,
  get: () => `/api/content/admin`,
  getById: (id) => `/api/content/admin/${id}`,
};

export const DashboardAPI = {
  reel: () => `/api/reel/admin/dashboard/count`,
  course: () => `/api/course/admin/dashboard/count`,
  video: () => `/api/video/admin/dashboard/count`,
  revenue: () => `/api/receipt/admin/dashboard/revenue`,
  userCountTotal: () => `/api/user/admin/dashboard/count`,
  educatorCountTotal: () => `/api/user/admin/dashboard/count/owner`,
  userLastMonth: () => `/api/user/admin/dashboard/count/last-month`,
  receiptLatest: () => `/api/receipt/admin/dashboard/latest`,
  newUsers: () => `/api/user/admin/dashboard/new-users`,
  bestChannels: () => `/api/channel/admin/dashboard/best-channels`,
};

export const MediaAPI = {
  create: () => `/api/gallery/admin`,
  get: () => `/api/gallery/admin`,
  delete: (id) => `/api/gallery/admin/id?id=${id}`,
  update: (id) => `/api/gallery/admin/${id}`,
};
